var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 297,
    viewBox: "0 0 297 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.736 0.000999451H23.264C10.436 0.000999451 0 10.436 0 23.264V47.053C0 59.88 10.436 70.316 23.264 70.316H273.737C286.564 70.316 297.001 59.881 297.001 47.053V23.264C297 10.436 286.564 0.000999451 273.736 0.000999451Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.736 113.344H23.264C10.436 113.344 0 123.779 0 136.605V160.394C0 173.221 10.436 183.657 23.264 183.657H273.737C286.564 183.657 297.001 173.222 297.001 160.394V136.605C297 123.779 286.564 113.344 273.736 113.344Z",
    fill: "#3B82F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.736 226.686H23.264C10.436 226.686 0 237.121 0 249.949V273.738C0 286.565 10.436 297 23.264 297H273.737C286.564 297 297 286.565 297 273.737V249.948C297 237.121 286.564 226.686 273.736 226.686Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.40583907a0e9e267756b915c48fccf66.svg";
export { ForwardRef as ReactComponent };